import { gql } from '@apollo/client'

export const REVIEW_FEEDBACK_FRAGMENT = gql`
  fragment ReviewFeedbackFields on ReviewFeedback {
    id
    workflow
    targetId
    note
    reviewerEmail
    createdAt
  }
`
